module.exports = __webpack_public_path__ + "static/media/venture_capital.689493ca.png";